import { Flex } from 'antd';
import { FC, memo, useState } from 'react';

import { AppMessage } from '@/common/components';
import { extractFormErrors, messageOnError } from '@/common/utils';

import { useInspectUrlInSearchConsoleMutation } from '@/modules/Domains';

import { SearchConsoleUrlInspectionLoadingView, SearchConsoleUrlInspectionResultView } from './SearchConsoleUrlInspectionFormResult';
import { SearchConsoleUrlInspectionFormView } from './SearchConsoleUrlInspectionFormView';

interface Props {
  siteId: string;
  domainId: string;
}

export const SearchConsoleUrlInspectionFormContainer: FC<Props> = memo(({ domainId, siteId }) => {
  const appMessageApi = AppMessage.useControls();
  const [choosenPageNodeId, setChoosenPageNodeId] = useState<string | undefined>(undefined);
  const [errors, setErrors] = useState<Record<string, string> | null>(null);

  const {
    mutate: inspectUrlMutation,
    isLoading: isUrlInspectionLoading,
    isSuccess: isUrlInspectionSuccess,
    data: inspectUrlResultData,
    reset: resetUrlInspectionResult,
  } = useInspectUrlInSearchConsoleMutation(siteId, domainId)({
    onError: (error) => {
      setErrors(extractFormErrors(error));
      messageOnError(error, appMessageApi);
    }
  });

  const handleChangePageNodeId = (value: string | undefined) => {
    setErrors(null);
    setChoosenPageNodeId(value);
  };

  const handleInspect = () => {
    if (!choosenPageNodeId) {
      setErrors({ pageNodeId: 'Сторінка є обовʼязкова' });
      return;
    }

    setErrors(null);

    inspectUrlMutation({ pageNodeId: choosenPageNodeId });
  };

  const handleResetResult = () => {
    resetUrlInspectionResult();
    setErrors(null);
    setChoosenPageNodeId(undefined);
  };

  return (
    <Flex wrap align="center" justify="center" gap={ 8 }>
      {
        isUrlInspectionLoading
          ? (
            <SearchConsoleUrlInspectionLoadingView/>
          )
          : !inspectUrlResultData && (
            <SearchConsoleUrlInspectionFormView
              siteId={ siteId }
              choosenPageNodeId={ choosenPageNodeId }
              errors={ errors }
              isUrlInspectionLoading={ isUrlInspectionLoading }
              handleChangePageNodeId={ handleChangePageNodeId }
              handleInspect={ handleInspect }
              handleResetResult={ handleResetResult }
            />
          )
      }
      {
        (!isUrlInspectionLoading && isUrlInspectionSuccess && inspectUrlResultData) && (
          <SearchConsoleUrlInspectionResultView
            inspectionResultData={ inspectUrlResultData }
            handleResetResult={ handleResetResult }
          />
        )
      }
    </Flex>
  );
});
